import React from "react";
import { SelectOption } from "@showitinc/showit-wc";

import Input from "../app2components/base/Input";
import DesignThemeStore from "../stores/DesignThemeStore";
import useStoreState from "./providers/useStoreState";
import { SELECT } from "../constants/InputConstants.mjs";
import { TEXT_STYLE_IDS } from "../constants/AppConstants";

function StyleSelectInput(props) {
  const themeStyles = useStoreState(DesignThemeStore, DesignThemeStore.getStyles);
  const { type, ...rest } = props;

  const getStyleList = () => {
    const { value } = props;
    const inputOptions = [];

    if (!value) {
      inputOptions.push(<option value="">-- Select --</option>);
    }

    if (themeStyles?.size) {
      themeStyles
        .filter((style) => style.get("type") === type)
        .sortBy((style) => TEXT_STYLE_IDS.indexOf(style.get("id")))
        .forEach((style) => {
          const id = style.get("id");
          const name = style.get("name");

          inputOptions.push(
            <SelectOption key={`user${id}`} value={id}>
              {name}
            </SelectOption>
          );

          if (value === `${id}+`) {
            inputOptions.push(
              <SelectOption key={`usermod${id}`} value={`${id}+`}>
                {`${name} +`}
              </SelectOption>
            );
          }
        });
    }

    return inputOptions;
  };

  return (
    <Input {...rest} inputType={SELECT}>
      {getStyleList()}
    </Input>
  );
}
 
export default StyleSelectInput;
